import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  DatePicker,
  Popconfirm,
} from "antd";

import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import CurrencyInput from "react-currency-input";
import moment from "moment";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const PosEarlyUnblockFrom = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {

    if (props.data) {

      form.setFieldsValue(props.data);

    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.unblockDate) {
      values.unblockDate = values.unblockDate.format("YYYY-MM-DD");
    }
    values.bankId = props.data.bankId;
    values.transactionIds = props.data.transactionIds;
    
    RequestHandler.post("/PosEarlyUnblock", values).then(
      (response) => {
        setLoading(false);
        if (response.success) {
          onSuccess();
        }
      }
    );
  };

  const onFinishFailed = () => setLoading(false);


  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="posEarlyUnblock"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row style={{ flexDirection: "row" }}>
        <Col span={24}>
          <Form.Item
            name="bank"
            label="Banka"
            initialValue={999}
          >
            <img src={props.data.bank} width={120}></img>
      
          </Form.Item>

          <Form.Item label="İşlem Adedi" name="count">
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="İşlem Tutarı"
            name="amount"
          >
            <CurrencyInput
              className="ant-input"
              decimalSeparator=","
              thousandSeparator="."
              disabled
            />
          </Form.Item>

          <Form.Item
            label="Net Tutar"
            name="netAmount"
          >
            <CurrencyInput
              className="ant-input"
              decimalSeparator=","
              thousandSeparator="."
              disabled
            />
          </Form.Item>

          <Form.Item label="Çözüm Tarihi" name="unblockDate" rules={[{ required: true }]}>
            <DatePicker format="DD.MM.YYYY"  style={{ width: "100%" }}/>
          </Form.Item>


          <Form.Item
            label="Anlaşılan Tutar"
            name="paidAmountString"
            rules={[{ required:true }]}
          >
            <CurrencyInput
              style={{ width: "100%" }}
              className="ant-input"
              decimalSeparator=","
              thousandSeparator="."
            />
          </Form.Item>

          <Row justify="space-between">
             <label style={{ color: "red" }}>Çözülen işlemler valör raporlarına yansıtılmayacaktır, erken bloke çözüm raporundan takibini yapabilirsiniz.</label>
          </Row>
  
        </Col>
      </Row>


       <Row style={{ flexDirection: "row" }}>
            <Col span={24} style={{ textAlign: "right" }}>
                <Popconfirm
                  title="Bloke çözümünü onaylıyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => {
                    setLoading(true);
                    form.submit();
                  }}
                  onCancel={() => setLoading(false)}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Bloke Çöz
                  </Button>
                </Popconfirm>
            </Col>
        </Row>
    </Form>
  );
};
export default PosEarlyUnblockFrom;
